@if (contractWrapForm) {
  <div class="bg-white p-xl-5 p-2">
    <div class="border-bottom border-gray">
      <button type="button" class="btn btn-icons float-start" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true">&times;</span>
      </button>
      @if (contract && contract.id) {
        <h3 class="text-end text-secondary pb-2">
          Contrat du {{ contract.beginDate | date }}
          @if (contract.endDate) {
            au {{ contract.endDate | date }}
          }
        </h3>
      }
      @if (!contract?.id) {
        <h3 class="text-end text-secondary pb-2">Création d'un contrat</h3>
      }
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="mb-3 text-secondary col-12">
          <small class="form-text text-secondary">Les champs marqués d'un * sont obligatoires. </small>
        </div>
      </div>

      <form [formGroup]="contractWrapForm">
        <div class="mb-3 col-12 col-lg-6">
          <label class="text-secondary required">Type de contrat</label>
          <select class="form-select" formControlName="contractType">
            @if (!contractWrapForm.value.contractType) {
              <option [ngValue]="" selected hidden></option>
            }
            @for (contractType of contractTypes | keyvalue: stringAscOrder; track contractType) {
              <option [ngValue]="contractType.value" [hidden]="contractType.value === 'Reprise IODAS'">
                {{ contractType.value }}
              </option>
            }
          </select>
        </div>
      </form>
      @if (!isEngagementContract) {
        <app-contract-details
          [beneficiary]="beneficiary"
          [contract]="contract"
          [contractTypeSelected]="contractWrapForm.value.contractType"
          (closeModal)="cancel()"
        ></app-contract-details>
      } @else {
        <app-contract-engagement-details
          [beneficiary]="beneficiary"
          [contract]="contract"
          [contractTypeSelected]="contractWrapForm.value.contractType"
          (closeModal)="cancel()"
        ></app-contract-engagement-details>
      }

      @if (traceability?.length !== 0 && isWorkflowedContract) {
        <div class="card border-0 card-border-radius-0 mt-4">
          <div class="card-body p-0">
            <div class="table-responsive">
              <div ngbAccordion [closeOthers]="false">
                <div ngbAccordionItem>
                  <h2 ngbAccordionHeader>
                    <button ngbAccordionButton class="accordion-button text-secondary">
                      <span id="traceabilityTitle">Traçabilité</span>
                    </button>
                  </h2>
                  <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                      <ng-template>
                        <div class="col px-0 pt-2">
                          <table class="table table-striped table-hover table-nowrap" aria-describedby="traceabilityTitle">
                            <thead class="text-secondary bg-light">
                              <tr>
                                <th scope="col" class="text-center">Etat</th>
                                <th scope="col" class="text-center">Date de l'état</th>
                                <th scope="col" class="text-center">Réalisé par</th>
                                <th scope="col" class="text-center">Commentaire</th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (trace of traceability; track $index) {
                                <tr>
                                  <td class="text-center">
                                    {{ trace.status }}
                                  </td>
                                  <td class="text-center">{{ trace.statusDate | date }}</td>
                                  <td class="text-center">
                                    {{ trace.performedBy }}
                                  </td>
                                  <td>{{ trace.comment }}</td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
